import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Typography
} from "@mui/material";
import { COLORS } from "../../../ui/Theme";
import { ShoppingCart } from "@mui/icons-material";
import { useSubscriptionContext } from "../../../context/subscription/SubscriptionContext";
import { useOrdersContext } from "../../../context/subscription/orders/OrdersContext";

const OrdersTable = () => {
    const { selectedPlan } = useSubscriptionContext();
    const { plansData } = useOrdersContext();

    return (
        <Paper
            sx={{
                width: "100%",
                height: "75vh",
                overflow: "hidden"
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                    mb: 4
                }}
            >
                <ShoppingCart sx={{ fontSize: "24px", color: COLORS.BLUE }} />
                <Typography sx={{ fontSize: "20px" }}>لیست سفارشات</Typography>
            </Box>

            <TableContainer
                sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    overflowY: "auto",
                    maxHeight: "calc(75vh - 80px)",
                }}
            >
                <Table
                    stickyHeader
                    sx={{
                        minWidth: 1100,
                        tableLayout: "auto",
                        height: "100%",
                    }}
                >
                    <TableBody sx={{ height: "100%" }}>

                        {/* Header Row */}
                        <TableRow>
                            <TableCell sx={{ width: "15%", fontWeight: "bold", textAlign: "center" }}>
                                نام اشتراک
                            </TableCell>
                            <TableCell sx={{ width: "10%", fontWeight: "bold", textAlign: "center" }}>
                                مدت زمان
                            </TableCell>
                            <TableCell sx={{ width: "15%", fontWeight: "bold", textAlign: "center" }}>
                                قیمت (تومان)
                            </TableCell>
                            {selectedPlan?.has_discount && (
                                <TableCell sx={{ width: "10%", fontWeight: "bold", textAlign: "center" }}>
                                    تخفیف %
                                </TableCell>
                            )}
                            <TableCell sx={{ width: "20%", fontWeight: "bold", textAlign: "center" }}>
                                قیمت نهایی
                            </TableCell>
                            <TableCell sx={{ width: "30%", fontWeight: "bold", textAlign: "center" }}>
                                توضیحات
                            </TableCell>
                        </TableRow>

                        {/* Data Row */}
                        <TableRow>
                            <TableCell sx={{ textAlign: "center" }}>
                                {selectedPlan?.plan_name ?? "-"}
                            </TableCell>

                            <TableCell sx={{ textAlign: "center" }}>
                                {selectedPlan?.duration ?? "-"}
                            </TableCell>

                            <TableCell sx={{ textAlign: "center" }}>
                                {selectedPlan?.price?.toLocaleString("fa-IR") ?? "-"}
                            </TableCell>

                            {selectedPlan?.has_discount && (
                                <TableCell sx={{ textAlign: "center" }}>
                                    {selectedPlan?.discount_percent ?? "-"}
                                </TableCell>
                            )}

                            <TableCell sx={{ textAlign: "center" }}>
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
                                    {plansData?.has_special_discount && (
                                        <span
                                            style={{
                                                textDecoration: "line-through",
                                                fontSize: "12px",
                                                color: COLORS.GRAY
                                            }}
                                        >
                                            {(selectedPlan?.has_discount && selectedPlan.discounted_price)
                                                ? selectedPlan.discounted_price.toLocaleString("fa-IR")
                                                : selectedPlan.price?.toLocaleString("fa-IR")}
                                        </span>
                                    )}

                                    <span>
                                        {plansData?.price?.toLocaleString("fa-IR") ?? "-"}
                                    </span>
                                </Box>
                            </TableCell>

                            <TableCell
                                sx={{
                                    textAlign: "center",
                                    whiteSpace: "normal",
                                    wordBreak: "break-word"
                                }}
                            >
                                {plansData?.desc ?? "-"}
                            </TableCell>
                        </TableRow>


                        <TableRow sx={{ height: "100%" }}>
                            <TableCell colSpan={10} sx={{ border: "none" }}></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>

        </Paper>
    );
};

export default OrdersTable;
